export const CURRENT_PLAN_DOWNLOAD_FILE_WEEKLY = 'current_plan_spend_weekly.xlsx';
export const CURRENT_PLAN_DOWNLOAD_FILE_MONTHLY = 'current_plan_spend_monthly.xlsx';
export const CURRENT_PLAN_WEEKLY_SPEND = 'current_plan_weekly_spend';
export const CURRENT_PLAN_MONTHLY_SPEND = 'current_plan_monthly_spend';
export const CURRENT_PLAN_WEEKLY_HEADERS = 'current_plan_column_headers_weekly';
export const DATA_KEY_SPEND = 'spend';
